import React from 'react';

import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { CREDIT_CARD_FIELDS } from '../constants';
import CreditCardInput from '../credit-card-input';

import style from './style.module.less';

const CreditCardCvv = () => {
  return (
    <div className={style['cvv-input']}>
      <CreditCardInput autoComplete={AutoCompleteField.CCCsc} className={style.cvv} data-private field={CREDIT_CARD_FIELDS.CVV} />
    </div>
  );
};

export default CreditCardCvv;
